// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lcN3","content":"styles_content__2pBSW","row":"styles_row__3uPYN","footer":"styles_footer__2u3D0","phraseLength":"styles_phraseLength__rjjFX"};